
import Vue from 'vue';
import { directive as onClickaway } from 'vue-clickaway';
import AuthService from '~/services/AuthService';
import DialogService from '~/services/DialogService';
import { User } from '~/services/IdentityService';
import URLS from '~/URLS';
import {
    CandidateProfileScore,
    CandidateProfileScorer,
} from '~/utils/candidate/CandidateProfileScorer';

interface ActionItem {
    label: string;
    action(): void;
}

export default Vue.extend({
    name: 'ProfileNavigation',
    directives: { onClickaway },
    props: {
        // The first letter of the firstName
        nameAbbr: {
            type: String,
            default: '',
        },
    },
    computed: {
        profile: {
            get() {
                return this.$store.getters['profileModule/getUser']();
            },
            set(value) {
                this.$store.commit('profileModule/setUser', value);
            },
        },
        candidate: {
            get() {
                return this.$store.getters['profileModule/getCandidate']();
            },
            set(value) {
                this.$store.commit('profileModule/setCandidate', value);
            },
        },
        workAuthorizations: {
            get() {
                return this.$store.getters['profileModule/getWorkAuthorizations']();
            },
            set(value) {
                this.$store.commit('profileModule/setWorkAuthorizations', value);
            },
        },
        score(): CandidateProfileScore | null {
            if (this.candidate && this.profile && this.workAuthorizations) {
                return new CandidateProfileScorer(
                    this.candidate,
                    this.profile,
                    this.workAuthorizations
                ).getProfileScore();
            }
            return null;
        },
        urls(): typeof URLS {
            return (this as any).$URLS;
        },
        user(): User | undefined {
            return this.profile || {};
        },
        fullName(): string {
            if (!this.user) return '';
            return (this.user.firstName || '') + ' ' + (this.user.lastName || '');
        },
        email(): string {
            if (!this.user) return '';
            return this.user.email || '';
        },
        profilePicture(): string {
            if (!this.user) return '';
            return this.user.avatar || '';
        },
        items(): ActionItem[] {
            const t = (id: string) =>
                this.$t(`components.navigation.profileNavigation.${id}`).toString();

            return [
                {
                    label: t('myCVs'),
                    action: () => {
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        this.$router.push(this.urls.profileDocuments);
                    },
                },
                {
                    label: t('favorites'),
                    action: () => {
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        this.$router.push(this.urls.favorites);
                    },
                },
                {
                    label: t('account'),
                    action: () => {
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        this.$router.push(this.urls.account);
                    },
                },
                {
                    label: t('faqs'),
                    action: () => {
                        window.open(
                            'https://intercom.help/talentsupport/en/collections/3407003-faq',
                            '_blank'
                        );
                    },
                },
                {
                    label: this.$t('shared.termsAndConds.privacyPolicy').toString(),
                    action: () => {
                        window.open('https://gethighered.com/privacy-policy/', '_blank');
                    },
                },
                {
                    label: t('cookies'),
                    action: () => {
                        DialogService.openCookieConsentDialog();
                    },
                },
                {
                    label: t('signOut'),
                    action: () => {
                        AuthService.logOut();
                    },
                },
            ];
        },
    },
    methods: {
        away() {
            this.$emit('close');
        },
        handleProfileClick() {
            this.$router.push(this.urls.spotlight);
            this.away();
        },
        handleItemClick(item: ActionItem) {
            item.action();
            this.away();
        },
    },
});
